module.exports = __webpack_public_path__ + "static/media/RomanBE.f4e99960.jpg";